import { Navigate } from 'react-router-dom';
import { auth } from '../firebase';
import { useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  // Session timeout - 30 minutes
  const resetTimer = useCallback(() => {
    const inactivityTimer = setTimeout(() => {
      auth.signOut();
      localStorage.clear(); // Clear any sensitive data
      sessionStorage.clear();
    }, 30 * 60 * 1000); // 30 minutes

    return inactivityTimer;
  }, []);

  useEffect(() => {
    let inactivityTimer = resetTimer();
    
    const handleActivity = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = resetTimer();
    };

    // Monitor all relevant user activities
    const events = ['mousemove', 'keypress', 'click', 'touchstart', 'scroll'];
    events.forEach(event => window.addEventListener(event, handleActivity));
    
    return () => {
      clearTimeout(inactivityTimer);
      events.forEach(event => window.removeEventListener(event, handleActivity));
    };
  }, [resetTimer]);

  // Show loading state
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  const currentPath = window.location.pathname;
  if (!user.emailVerified && currentPath !== '/verify-email') {
    return <Navigate to="/verify-email" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
